import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { getApprovedForms } from '../../api/Api';
import { FaEye } from 'react-icons/fa';
import { Search } from 'lucide-react'; // Assuming you're using lucide-react for icons
import Loader from '../../Loader/Loader';
import Pagination from '../../Loader/Pagination';
import { Filter } from "lucide-react";
import { AuthContext } from "../../utils/AuthContext";
import { generateAcademicYears } from "../../utils/academicYearUtils";
const OverallPayment = () => {
  const [approvedForms, setApprovedForms] = useState([]);
  const [filteredForms, setFilteredForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const navigate = useNavigate();
const { academicYear, setAcademicYear } = useContext(AuthContext);

const academicYears = generateAcademicYears();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getApprovedForms();
        if (response.success && Array.isArray(response.data)) {
          setApprovedForms(response.data);
          setFilteredForms(response.data);
          console.log(response.data)
        } else {
          console.error('Unexpected response format:', response);
        }
      } catch (error) {
        console.error('Error fetching approved forms:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
  filterData();
}, [
  searchQuery,
  startDate,
  endDate,
  approvedForms,
  academicYear
]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
    setCurrentPage(1);
  };
useEffect(() => {
  setCurrentPage(1);
}, [academicYear]);
const filterData = () => {

  const filtered = approvedForms.filter((form) => {

    const fullName =
      form?.particularsOfChild?.fullName?.toLowerCase() || "";

    const invoiceNo =
      form?.invoiceNo?.toLowerCase() || "";

    const registerNo =
      form?.registerNo?.toLowerCase() || "";

    const admissionFor =
      form?.admissionFor?.toLowerCase() || "";

    const searchMatch =
      fullName.includes(searchQuery) ||
      invoiceNo.includes(searchQuery) ||
      registerNo.includes(searchQuery) ||
      admissionFor.includes(searchQuery);

    // Academic Year Filter
    const academicYearMatch =
      !academicYear ||
      form?.academicYear === academicYear;

    // Date Filter
    const formDate = new Date(form.createdAt);

    const isAfterStart =
      startDate
        ? formDate >= new Date(startDate)
        : true;

    const isBeforeEnd =
      endDate
        ? formDate <= new Date(endDate)
        : true;

    return (
      searchMatch &&
      academicYearMatch &&
      isAfterStart &&
      isBeforeEnd
    );

  });

  setFilteredForms(filtered);

};

  const totalPages = Math.ceil(filteredForms.length / itemsPerPage);
  const currentData = filteredForms.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <div className="p-4">

<div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4 mb-5">

  <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between gap-4">

    {/* Left Side */}
    <div className="flex flex-wrap items-center gap-3">

      {/* Title */}
      <div className="mr-4">
        <h2 className="text-2xl font-bold text-[#16bab1]">
          Fee Bill
        </h2>

        <p className="text-sm text-gray-500">
          View overall fee payment details
        </p>
      </div>

      {/* Academic Year Filter */}
      <div className="flex items-center gap-2 bg-gray-50 px-3 py-2 rounded-xl border border-gray-200 min-w-[170px]">

        <Filter size={16} className="text-[#16bab1]" />

        <div className="flex flex-col w-full">

          <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
            Academic Year
          </label>

          <select
            value={academicYear}
            onChange={(e) => setAcademicYear(e.target.value)}
            className="bg-transparent text-sm font-semibold text-gray-700 outline-none cursor-pointer"
          >
            <option value="">Overall View</option>

            {academicYears.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}

          </select>

        </div>
      </div>

      {/* Search */}
      <div className="relative">

        <Search
          className="absolute left-3 top-3 text-gray-400"
          size={18}
        />

        <input
          type="search"
          value={searchQuery}
          onChange={handleSearch}
          placeholder="Search invoice or student..."
          className="w-[260px] pl-10 pr-4 py-2.5 border border-gray-300 rounded-xl outline-none focus:ring-2 focus:ring-[#16bab1]"
        />
      </div>

      {/* Date Filters */}
      <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-3 py-2">

        <div className="flex flex-col">
          <label className="text-[10px] font-bold text-gray-400 uppercase">
            From
          </label>

          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="bg-transparent outline-none text-sm"
          />
        </div>

        <div className="w-px h-8 bg-gray-300"></div>

        <div className="flex flex-col">
          <label className="text-[10px] font-bold text-gray-400 uppercase">
            To
          </label>

          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="bg-transparent outline-none text-sm"
          />
        </div>

      </div>

    </div>

  </div>

</div>

      {/* Table and Data */}
      {loading ? (
        <Loader />
      ) : filteredForms.length === 0 ? (
        <p className='text-center text-[#16bab1]'>No approved forms available.</p>
      ) : (
        <div className="overflow-auto">
          <table className="min-w-full table-auto border border-gray-300">
            <thead className="bg-[#16bab1]">
              <tr>
                <th className="py-2 px-4 text-white border">S.No</th>
                <th className="border px-4 py-2 text-white">Invoice No</th>
                <th className="border px-4 py-2 text-white">Child Name</th>
                {/* <th className="border px-4 py-2 text-white">Name</th> */}
                <th className="border px-4 py-2 text-white">Admission For</th>
                <th className="border px-4 py-2 text-white">Year</th>
                <th className="border px-4 py-2 text-white">Fee Amount</th>
                <th className="border px-4 py-2 text-white">Paid Fee</th>
                <th className="border px-4 py-2 text-white">Action</th>
              </tr>
            </thead>
            <tbody>
              {currentData.map((form, index) => (
                <tr key={form._id} className="text-[#16bab1]">
                  <td className="py-2 px-4 border">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td className="border px-4 py-2">{form.invoiceNo}</td>
                  <td className="border px-4 py-2">{form.particularsOfChild.fullName}</td>
                  {/* <td className="border px-4 py-2">{form.}</td> */}
                  <td className="border px-4 py-2">{form.admissionFor}</td>
                  <td className="border px-4 py-2">{form.academicYear}</td>
                  <td className="border px-4 py-2">₹{form.feeAmount}</td>
                  <td className="border px-4 py-2">₹{form.paidFee}</td>
                  <td className="border px-4 py-2">
                    <button
                      onClick={() => navigate(`/admin/invoice/${form._id}`)}
                      className="text-blue-600 hover:text-blue-800 flex items-center mx-auto"
                    >
                      <FaEye className="mr-1" />
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      )}
    </div>
  );
};

export default OverallPayment;
